/**
 * @generated SignedSource<<e6767a136be41426dec31e7bff4889ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlights_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AirportSelect_data" | "PackageEditTransportFlightsRow_data">;
  readonly " $fragmentType": "PackageEditTransportFlights_data";
};
export type PackageEditTransportFlights_data$key = {
  readonly " $data"?: PackageEditTransportFlights_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlights_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlights_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlightsRow_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AirportSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "60be9c7578b5196e9cc831c3ecff3258";

export default node;
